import React, { useState, useRef, useEffect } from 'react';
import Box from '@mui/material/Box';
import { styled } from '@mui/system';
import { CircularProgress, Button } from '@mui/material';
import { uploadToS3 } from '../helpers/uploadToS3';

const styles = {
    loader: {
        position: 'absolute',
        left: '0px',
        top: '0px',
        width: '100%',
        height: '100%',
        zIndex: 9999,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    }
};

const Input = styled('input')({
    display: 'none'
});

function Upload({ dirName, img, onURL, fileName, defaultImg = '', btn_name = 'Upload' }) {
    const fileInput = useRef();
    const [image, setImage] = useState(img);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setImage(img);
    }, [img]);

    const handleUpload = async () => {
        const file = fileInput.current.files[0];
        if (!file) return;

        setLoading(true);
        try {
            const { publicUrl, path } = await uploadToS3({ file, dirName });
            setImage(publicUrl);
            onURL(path);
        } catch (err) {
            console.error('Upload failed:', err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box style={{ textAlign: 'center', width: 200, margin: 'auto' }}>
            <label htmlFor="contained-button-file">
                <Input accept="image/*" id="contained-button-file" type="file" ref={fileInput} onChange={(e) => handleUpload()} />
                <Button variant="contained" component="span">
                    {btn_name}
                </Button>
            </label>
            <br />
            <img className="upload-image-preview" src={image && image.length > 0 ? image : defaultImg} width="200" alt="img" style={{ border: '1px black solid' }}></img>
            {loading && (
                <div style={styles.loader}>
                    <CircularProgress />
                </div>
            )}
        </Box>
    );
}

export default Upload;
